import React from 'react';
interface CompletionMeterProps {
  percentage: number;
  variant?: 'light' | 'dark';
}
export function CompletionMeter({
  percentage,
  variant = 'dark'
}: CompletionMeterProps) {
  const isLight = variant === 'light';
  const textColor = isLight ? 'text-white' : 'text-gray-700';
  const trackColor = isLight ? 'text-slate-700' : 'text-gray-200';
  const progressColor = isLight ? 'text-blue-400' : 'text-blue-600';
  return <div className="flex items-center gap-2" data-id="element-8">
      <div className="relative w-8 h-8 flex-shrink-0" data-id="element-9">
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36" data-id="element-10">
          <path className={trackColor} strokeWidth="3" stroke="currentColor" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" data-id="element-11" />
          <path className={`${progressColor} transition-all duration-500 ease-out`} strokeDasharray={`${percentage}, 100`} strokeWidth="3" strokeLinecap="round" stroke="currentColor" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" data-id="element-12" />
        </svg>
      </div>
      <span className={`text-sm font-bold ${textColor}`} data-id="element-13">{percentage}%</span>
    </div>;
}